const pathnamePrefixes = ['/jira/', '/wiki/', '/browse/'];

export const normaliseUrl = (url: string) => {
	try {
		let parsedUrl = new URL(url);

		let normalizedPath = '/any/';

		const prefixRegex = new RegExp(`^(${pathnamePrefixes.join('|')})`);
		if (prefixRegex.test(parsedUrl.pathname)) {
			normalizedPath = parsedUrl.pathname.match(prefixRegex)![0];
		}

		const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
		return normalizedUrl;
	} catch (error) {
		return 'https://could-not-parse.example.com';
	}
};
